import React, { useEffect, useState } from "react";

import GoBackHeader from "../GoBackHeader/GoBackHeader";
import Departments from "../Departments/Departments";
import Footer from "../Footer/Footer";
import SchoolOverview from "../SchoolOverview/SchoolOverview";

const School = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
  const handleWidthChange = () => {
    // setWidth(window.innerWidth);
    // console.log("mobile", isMobile);
    if (window.innerWidth > 1000) {
      setIsMobile(false);
      // window.location.reload();
    } else if (window.innerWidth <= 1000) {
      setIsMobile(true);
    }
  };
  useEffect(() => {
    window.addEventListener("resize", handleWidthChange);
    window.scrollTo({ top: 0 });
  }, []);

  if (!isMobile) {
    return (
      <>
        <GoBackHeader />
        <Departments small={true} />
        <SchoolOverview/>
        <Footer enableScroll={false} />
        <div id="portal"></div>
      </>
    );
  } else {
    return (
      <>

      </>
    );
  }
};
export default School;
